import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { CHART_COLORS } from '../../utils/constants';
import { formatINRCompact } from '../../utils/formatters';

export function ExpenseBreakdown({ categories, onSliceClick }) {
  const data = (categories || []).map((c, i) => ({
    name: c.name,
    value: c.amount,
    fill: CHART_COLORS[i % CHART_COLORS.length],
  }));

  if (!data.length) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-slate-800">Expense breakdown</h3>
      <p className="mb-2 text-xs text-slate-500">Click a slice to drill down</p>
      <div className="h-64 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={56}
              outerRadius={88}
              paddingAngle={2}
              onClick={(entry) => entry?.name && onSliceClick?.(entry.name)}
            >
              {data.map((entry, index) => (
                <Cell key={entry.name} fill={entry.fill} className="cursor-pointer" />
              ))}
            </Pie>
            <Tooltip formatter={(v) => formatINRCompact(v)} />
            <Legend layout="horizontal" verticalAlign="bottom" />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
